import { render, staticRenderFns } from "./PointData.vue?vue&type=template&id=00511181&scoped=true"
import script from "./PointData.vue?vue&type=script&lang=js"
export * from "./PointData.vue?vue&type=script&lang=js"
import style0 from "./PointData.vue?vue&type=style&index=0&id=00511181&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00511181",
  null
  
)

export default component.exports